<template>
    <GeneralCoachMarble :class="[isLoading && `loadingMarble ${sizeClass}`]"></GeneralCoachMarble>
</template>

<script lang="ts">
export enum MarbleSize {
    SMALL = "small",
    BASE = "base",
    BIG = "big",
}
</script>

<script setup lang="ts">
import GeneralCoachMarble from "~vue/components/navigation/CoachingModeMarbles/GeneralCoachMarble.vue";
import { computed } from "vue";

type CoachingModeMarbleProps = {
    size?: `${MarbleSize}`;
    isLoading?: boolean;
};

const { size = MarbleSize.BASE, isLoading = false } = defineProps<CoachingModeMarbleProps>();

const sizeClass = computed(() => {
    const sizes: Record<MarbleSize, string> = {
        small: "w-12 h-12",
        base: "w-16 h-16",
        big: "w-16 h-16 md:w-28 md:h-28",
    };

    return sizes[size];
});
</script>

<style scoped>
.loadingMarble {
    animation: spinningMarble 2s cubic-bezier(0.65, 0, 0.25, 1.1) infinite;
    animation-delay: 300ms;
}

@keyframes spinningMarble {
    100% {
        transform: rotate(360deg);
    }
}
</style>
